import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MailIcon from '@material-ui/icons/Mail';
import { openModal } from 'Helpers/ModalHelper';
import modalConsts from 'Consts/ModalNames';

const styles = (theme) => ({
  root: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
  },
  icon: {
    marginRight: theme.spacing(0.5),
  },
});

const ShareSchedulerLink = ({
  className,
  classes,
}) => {
  const handleOpenInstantBooker = () => {
    openModal(modalConsts.instantBookerModal);
  };

  return (
    <div
      role="presentation"
      onClick={handleOpenInstantBooker}
      className={classNames(classes.root, className)}
    >
      <MailIcon className={classNames(classes.icon)} />
      <div>
        Share Calendar Link
      </div>
    </div>
  );
};

ShareSchedulerLink.defaultProps = {
  className: '',
};

ShareSchedulerLink.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ShareSchedulerLink);
